import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

const LocationInstructions = ({ stop }) => {
  const locationInstructions = useMemo(() => {
    return stop.getIn(['location', 'deliveryInstructions'])
  }, [stop]);

  return (
    <Flex
      shouldShow={locationInstructions}
      alignItems="center"
      className="location-instructions-item"
    >
      <div>{locationInstructions}</div>
    </Flex>
  );
}

LocationInstructions.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default LocationInstructions;
